module.exports = __webpack_public_path__ + "static/profile-2d72f3cae68a38777dd8a6a93343fce4.png";